import Image from "next/image";
import React from "react";

import Paragraph from '../../Paragraph/Paragraph';
import styles from "./Intro.module.scss";

export default function Intro() {
  return (
    <div className={styles['intro-container']}>
      <div className={styles.content}>
        <Paragraph
          title="Giới thiệu một chút về bản thân đến VnRebates và các khách hàng tại Việt Nam được không?"
          content={[
            'Tôi là James Clyde, CEO của PipFarm. Tôi là một chuyên gia về giao dịch trực tuyến với mười năm kinh nghiệm trong việc quản lý các công ty công nghệ tài chính. Tôi được biết đến nhiều nhất với vai trò là giám đốc điều hành tại cTrader, một trong những nền tảng giao dịch forex phổ biến nhất, được các sàn môi giới và các quỹ giao dịch hàng đầu thế giới sử dụng.',
            'Năm 2023, tôi đã thành lập PipFarm, một quỹ trực tuyến. Chúng tôi cung cấp các thử thách giao dịch mô phỏng với quỹ ảo trên nền tảng cTrader nổi tiếng. Các nhà giao dịch vượt qua thử thách sẽ nhận được tài khoản cấp vốn để quản lý và được chia ít nhất 70% và lên tới 95% lợi nhuận mà họ tạo ra.',
          ]}
        />
      </div>
      <div className={styles['eli-container']}>
        <Image
          src="/images/landing_page_pipfarm/Ellipse1.png"
          alt="Ellipse Icon"
          width={521}
          height={521}
        />
      </div>
    </div>
  );
}
